import { FormControl, InputLabel } from '@mui/material';
import CSS from 'csstype';

import { useTrans } from "~/hooks/useTrans";
import { MyMenuItem, MySelect } from "~/mui/MySelect";
import { TCatalogQuality } from "~/providers/interfaces";

export type TCatalogQualitySelectValues = "none" | TCatalogQuality;

interface ICatalogQualitySelect {
	value: TCatalogQualitySelectValues;
	hasNone?: boolean;
	sx?: CSS.Properties;
	onChange?: (newValue: TCatalogQualitySelectValues) => void;
}

export default function CatalogQualitySelect({
	value,
	hasNone = true,
	sx = {},
	onChange = () => {},
}: ICatalogQualitySelect) {
	const { trans } = useTrans();

	return <FormControl size="small" sx={sx}>
		<InputLabel>
			{ trans("adminProjectCatalogModal.quality.title") }
		</InputLabel>
		<MySelect
			value={value}
			onChange={event => onChange(event.target.value as TCatalogQualitySelectValues)}
			label={trans("adminProjectCatalogModal.quality.title")}
		>
			{ hasNone && <MyMenuItem value="none">{ trans("projectFilter.all") }</MyMenuItem> }
			<MyMenuItem value="vip">{ trans("adminProjectCatalogModal.quality.value.vip") }</MyMenuItem>
			<MyMenuItem value="interesting">{ trans("adminProjectCatalogModal.quality.value.interesting") }</MyMenuItem>
			<MyMenuItem value="neutral">{ trans("adminProjectCatalogModal.quality.value.neutral") }</MyMenuItem>
			<MyMenuItem value="uninteresting">{ trans("adminProjectCatalogModal.quality.value.uninteresting") }</MyMenuItem>
			<MyMenuItem value="undetermined">{ trans("adminProjectCatalogModal.quality.value.undetermined") }</MyMenuItem>
		</MySelect>
	</FormControl>;
}
